import React from "react";
import { Container, Row } from "react-bootstrap";
import Supplies from "../Supplies";
import Layout from "../shared/Layout";

const SuppliesPage = () => {
  return (
    <Layout>
      <Container>
        <Row>
          <Supplies />
        </Row>
      </Container>
    </Layout>
  );
};

export default SuppliesPage;
